export default __webpack_public_path__ + "static/media/ThinkHealth.37a58d0e066e79ae27277c993c89834f.webp";